module.exports = __webpack_public_path__ + "img/icon_map_7_on_110.a3e93248.png";